import {
  arrayToColumnVector,
  createMatrix,
  extractColumn,
  fallbackSolver,
  normalizeValue,
  roundArray,
  solveLinearSystem,
  sumColumn,
} from './matrix.js';

function calculateBaseStakes({
  matrix,
  distribution,
  fixedValueId,
  sumStake,
  stakes,
}) {

  const matrixObj = createMatrix(matrix);
  const distributionVector = arrayToColumnVector(distribution);
  const solution =
    solveLinearSystem(matrixObj, distributionVector) ||
    fallbackSolver(matrixObj);

  if (solution) {
    if (fixedValueId === 'sum') {
      const scaled = solution.multiply(sumStake / sumColumn(solution));
      return extractColumn(scaled);
    }

    const index = Number(fixedValueId);
    const stakeValue = stakes[index];
    const scaled = solution.multiply(stakeValue / solution.e(index + 1, 1));
    return extractColumn(scaled);
  }
}

export function stakesCalculated({
  matrix,
  distributions,
  fixedValueId,
  sumStake,
  stakes,
  fromSumCurrencyRates,
  isRoundStakes,
  isRoundExchangeRates,
  roundToValues,
  roundStakesTo,
}) {
  const baseStakes = calculateBaseStakes({
    matrix,
    distribution: distributions,
    fixedValueId,
    sumStake: normalizeValue(sumStake),
    stakes,
  });

  const result = baseStakes.map(
    (value, index) => value * fromSumCurrencyRates[index],
  );


  if (!isRoundStakes) {
    return result;
  }

  let stakesRounded = (isRoundExchangeRates
    ? roundArray(result, roundToValues)
    : roundArray(result, roundStakesTo))
  
  if( fixedValueId !== "sum"){
    stakesRounded[fixedValueId] = result[fixedValueId];
  }

  return stakesRounded;
}


/*


let matrix0 = [
  [ 1.1099999999999999, -1, -1 ],
  [ 0, 0.55, -0.5 ],
  [ -1, 0.55, 1.08 ]
];
let distributions0 = [true, true, true]
let fixedValueId0 = 0;
let sumStake0 = 80;
let stakes0 = [612.34, 0, 0];
let fromSumCurrencyRates0 = stakes0.map(__item => 1)
let isRoundStakes0 = true;
let isRoundExchangeRates0 = false;
let roundStakesTo0 = 7.7;
let roundToValues0 = stakes0.map(__item => roundStakesTo0);


let resultBoy = stakesCalculated({
  matrix:matrix0,
  distributions:distributions0,
  fixedValueId:fixedValueId0,
  sumStake:sumStake0,
  stakes:stakes0,
  fromSumCurrencyRates:fromSumCurrencyRates0,
  isRoundStakes:isRoundStakes0,
  isRoundExchangeRates:isRoundExchangeRates0,
  roundToValues: roundToValues0,
  roundStakesTo:roundStakesTo0,
})

console.log("resultBoy", resultBoy);
*/